import { lazy } from 'react';

import type { RouteObject } from 'react-router-dom';

/**
 * Rotas do módulo de doações.
 *
 * `/donations` é **pública, sem guard** — a RLS de `donation_requests` libera
 * `anon`, e quem quer doar frequentemente ainda não tem conta (DD-01). É a mesma
 * escolha de `/content`.
 *
 * A gestão fica sob `institutions/:id`, fora do `AppLayout` e sob
 * `RequireSession`, como a gestão de chamados: é fluxo de tarefa com formulário.
 */
const DonationsPage = lazy(() => import('./routes/Donations.page'));
const InstitutionDonationsPage = lazy(() => import('./routes/InstitutionDonations.page'));

export const donationsRoutes: RouteObject[] = [{ path: 'donations', element: <DonationsPage /> }];

export const donationsProtectedRoutes: RouteObject[] = [
  { path: 'institutions/:id/donations', element: <InstitutionDonationsPage /> },
];
